module.exports = __webpack_public_path__ + "static/media/faq.2ad94ab3.jpg";